import { Modal, Form, Spin } from 'antd';
import styled from 'styled-components';

export const ExportProjectModal = styled(Modal)`
    width: 680px !important;
    height: 347px !important;

    .ant-modal-body {
        padding: 32px 40px 41px 40px;
    }

    .ant-modal-content {
        border-radius: 6px;
    }
    #csv-link {
        opacity: 0;
        position: absolute;
    }
`;

export const ExportFavoriteToCSVForm = styled(Form)`
    margin-top: 28px;
`;

export const ExportSpin = styled(Spin)`
    top: 0 !important;
`;
